import React, { useEffect } from "react";
import { observer } from "mobx-react-lite";
import { useStores } from "@/stores/useStores";
import LoadingIndicator from "@/components/layout/org/LoadingIndicator";

import SessionExpiredDialog from "../sessions/SessionExpiredDialog";
import SessionExpiringDialog from "../sessions/SessionExpiringDialog";

export const AuthenticationProvider = observer(({ children }) => {
  const { authenticationStore } = useStores();

  useEffect(() => {
    authenticationStore.init();
  }, [authenticationStore]);

  if (authenticationStore.isAuthenticated) {
    return (
      <>
        {children}
        <SessionExpiredDialog
          visible={authenticationStore.sessionStore.status === "expired"}
          processing={authenticationStore.processing}
          onCancel={() => authenticationStore.sessionStore.setStatus("none")}
          onLogin={() => authenticationStore.loginRedirect()}
        />
        <SessionExpiringDialog
          visible={authenticationStore.sessionStore.status === "expiring"}
          processing={authenticationStore.sessionStore.processing}
          onCancel={() => authenticationStore.sessionStore.setStatus("none")}
          onExtend={() => authenticationStore.sessionStore.extendSession()}
        />
        <iframe id={authenticationStore.iframeId} style={{ visibility: "hidden", height: "0px" }} />
      </>
    );
  }
  return (
    <div className="flex h-full flex-col items-center justify-center">
      <LoadingIndicator center message="logging in..." />
      <iframe id={authenticationStore.iframeId} style={{ visibility: "hidden", height: "0px" }} />
    </div>
  );
});
